import React, { useState } from "react";
import "./Navbar.scss";
import logo from "../../assets/Logos/Cryptoants.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { serverAddr } from "../../networkConfig";
import {
  AppBar,
  Container,
  Box,
  IconButton,
  Collapse,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

export default function Navbar() {
  const isLoggedIn = !!localStorage.getItem("token");
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLogout = async () => {
    setMobileOpen(false);
    setAnchorEl(null);
    try {
      const refreshToken = localStorage.getItem("refresh_token");
      await serverAddr.post("auth/logout/", { refresh: refreshToken });
    } catch (_) {
      // proceed with logout even if API fails
    }
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  const closeNavbar = () => setMobileOpen(false);

  const navLinks = isLoggedIn ? (
    <>
      <NavLink
        to="/MyView"
        onClick={closeNavbar}
        className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
      >
        My View
      </NavLink>
      <NavLink
        to="/expertview"
        onClick={closeNavbar}
        className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
      >
        Expert View
      </NavLink>
      {/* <NavLink
        to="/publisher"
        onClick={closeNavbar}
        className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
      >
        Publisher
      </NavLink> */}
    </>
  ) : null;

  const avatarButton = (
    <button
      className="avatar-circle"
      onClick={(e) => setAnchorEl(e.currentTarget)}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" />
      </svg>
    </button>
  );

  return (
    <>
      <AppBar
        component="nav"
        position="sticky"
        className="custom-nav"
        elevation={0}
        sx={{ bgcolor: "#070707" }}
      >
        <Container className="container">

          {/* Main row */}
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

            {/* Logo */}
            <NavLink
              to="/"
              onClick={closeNavbar}
              style={{ display: "flex", alignItems: "center", textDecoration: "none" }}
            >
              <img
                src={logo}
                alt="Logo"
                className="logo-img"
              />
            </NavLink>

            {/* Desktop Menu */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                flex: 1,
              }}
            >
              {/* Center nav links */}
              <Box sx={{ display: "flex", justifyContent: "center", flex: 1 }}>
                {navLinks}
              </Box>

              {/* Right side */}
              <div className="nav-right">
                {isLoggedIn && (
                  <NavLink to="/publisher" className="nav-link" onClick={closeNavbar}>
                    Publisher
                  </NavLink>
                )}
                <div className="contact-text">
                  <span>📞 Contact us : </span>
                  <a href="tel:9321765323" className="contact-number">
                    9321765323
                  </a>
                </div>

                {isLoggedIn ? (
                  avatarButton
                ) : (
                  <NavLink to="/login" className="nav-link">
                    Login
                  </NavLink>
                )}
              </div>
            </Box>

            {/* Mobile hamburger */}
            <IconButton
              sx={{ display: { md: "none" }, color: "#fff" }}
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
          </Box>

          {/* Mobile Collapse */}
          <Collapse
            in={mobileOpen}
            sx={{
              display: { md: "none" },
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              bgcolor: "#070707",
              zIndex: 1200,
              borderBottom: "1px solid #1a1a2e",
            }}
          >
            <Box sx={{ px: 2, pb: 2, display: "flex", flexDirection: "column", gap: "4px" }}>
              {navLinks}

              <Box sx={{ mt: 1 }}>
                <div className="contact-text" style={{ marginBottom: "12px" }}>
                  <span>📞 Contact us : </span>
                  <a href="tel:9321765323" className="contact-number">
                    9321765323
                  </a>
                </div>

                {isLoggedIn ? (
                  <>
                    <NavLink to="/publisher" className="nav-link" onClick={closeNavbar}>
                      Publisher
                    </NavLink>
                    <span className="nav-link" style={{ cursor: "pointer" }} onClick={handleLogout}>
                      Logout
                    </span>
                  </>
                ) : (
                  <NavLink to="/login" className="nav-link" onClick={closeNavbar}>
                    Login
                  </NavLink>
                )}
              </Box>
            </Box>
          </Collapse>

        </Container>
      </AppBar>

      {/* Shared dropdown menu for avatar */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            background: "#1a1a2e",
            border: "1px solid #2a2a4a",
            minWidth: 140,
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* <MenuItem
          onClick={() => setAnchorEl(null)}
          sx={{
            color: "#fff",
            "&:hover": { bgcolor: "rgba(0,194,255,0.15)", color: "#00c2ff" },
          }}
        >
          Profile
        </MenuItem> */}
        <MenuItem
          onClick={handleLogout}
          sx={{
            color: "#fff",
            "&:hover": { bgcolor: "rgba(0,194,255,0.15)", color: "#00c2ff" },
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
